import { ImageGalleriesImageContent } from 'components/minute/sidebar/MarkerSidebar/shared/ImageGalleriesSubsection/ImageGalleriesImageContent';
import { ImageGalleriesSymbolContent } from 'components/minute/sidebar/MarkerSidebar/shared/ImageGalleriesSubsection/ImageGalleriesSymbolContent';
import { OptionRowComponentSwitch } from 'components/minute/sidebar/shared/OptionRowComponentSwitch';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { motion } from 'framer-motion';
import { useCreateWorldMarkerV2 } from 'hooks/marker/v2/useCreateWorldMarkerV2';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ImageToolSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const createWorldMarker = useCreateWorldMarkerV2();

    function createNewImageMarkerInCenter(imageUrl: string, type: 'image' | 'icon') {
        const createInSize = (width: number, height: number) => {
            const center = mapRef.getCenter();
            const centerXY = mapRef.project([center.lng, center.lat]);

            const corners = [
                { x: centerXY.x - width / 2, y: centerXY.y - height / 2 },
                { x: centerXY.x + width / 2, y: centerXY.y - height / 2 },
                { x: centerXY.x + width / 2, y: centerXY.y + height / 2 },
                { x: centerXY.x - width / 2, y: centerXY.y + height / 2 }
            ];
            const coordinates = corners
                .map((corner) => ctxEdit.mapRef?.current.unproject([corner.x, corner.y]))
                .map((e) => ({ lat: e.lat, lng: e.lng }));
            createWorldMarker.createImage({ type: type, url: imageUrl }, coordinates);
        };

        const mapRef = ctxEdit.mapRef.current;

        if (type === 'image') {
            mapRef.loadImage(imageUrl, (error, image) => {
                const width = 150;
                const height = (width * image.height) / image.width;
                createInSize(width, height);
            });
        } else {
            createInSize(150, 150);
        }
    }

    return (
        <motion.div {...ANIMATION_APPEAR}>
            <S_ImageToolSidebar className={props.className}>
                <SidebarSubsection title={Localization.GALLERY} icon={{ iconName: 'images' }}>
                    <SidebarContent>
                        <OptionRowComponentSwitch
                            initialSelectedIndex={0}
                            options={[
                                {
                                    menuItem: { text: Localization.IMAGE },
                                    element: (
                                        <ImageGalleriesImageContent
                                            dragAndDropEnabled
                                            selectedImageUrl={null}
                                            galleryType={'image'}
                                            // initialRowsVisible={12}
                                            onSelected={(imageUrl) =>
                                                createNewImageMarkerInCenter(imageUrl, 'image')
                                            }
                                        />
                                    )
                                },
                                {
                                    menuItem: { text: Localization.SYMBOL },
                                    element: (
                                        <ImageGalleriesSymbolContent
                                            dragAndDropEnabled
                                            marker={null}
                                            // initialRowsVisible={12}
                                            onSelected={(data) => {
                                                createNewImageMarkerInCenter(data.imageUrl, 'icon');
                                            }}
                                        />
                                    )
                                }
                            ]}
                        />
                    </SidebarContent>
                </SidebarSubsection>
            </S_ImageToolSidebar>
        </motion.div>
    );
};

const S_ImageToolSidebar = styled.div`
    width: 100%;
`;
